import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';

export default class PanelComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentPanel | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.components = settings?.components
			? settings.components.map((/** @type {any} */ c) => createComponentInstance(c))
			: [];
		this.theme = settings?.theme ?? 'default';
		this.title = settings?.title ?? '';
	}
}
